// Action Types
export const ENTITLEMENT_WINDOW_SUCCESS = 'ENTITLEMENT_WINDOW_SUCCESS';
export const ENTITLEMENT_WINDOW_FAILURE = 'ENTITLEMENT_WINDOW_FAILURE';
export const ENTITLEMENT_WINDOW_LOADING = 'ENTITLEMENT_WINDOW_LOADING';
export const ENTITLEMENT_REVIEW_WINDOW_FORM_CONTACTS_LOOKUPS_SUCCESS = 'ENTITLEMENT_REVIEW_WINDOW_DETAIL_FORM_CONTACTS_LOOKUPS_SUCCESS';